import { render } from "./BackerCenterUpdateFeedPreview.vue?vue&type=template&id=2f396b66"
import script from "./BackerCenterUpdateFeedPreview.vue?vue&type=script&lang=js"
export * from "./BackerCenterUpdateFeedPreview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__